import { FC } from "react";
import styles from "./catalogues-page.module.scss";
import { Sidebar } from "../../components/sidebar/sidebar";
import { Catalogues } from "../../features/catalogues/catalogues";
import { Outlet } from "react-router-dom";


export const CataloguesPage: FC = () => {
  return (
    <div className={styles.page}>
      <Sidebar>
        <Catalogues />
      </Sidebar>
      <Outlet />
    </div>
  );
};
